import { WithDefaultLayout } from '@/components/DefautLayout'
import PhilosophyCard from '@/components/PhilosophyCard';
import RegistrationButton from '@/components/RegistrationButton';
import TitleTemp from '@/components/TitleTemp';
import { Page } from '@/types/Page'
import { faChartLine, faLightbulb, faPeopleGroup } from '@fortawesome/free-solid-svg-icons';
import React from 'react'

const Home = () => {
    return (
        <div className="relative md:h-[500px] h-[600px] overflow-hidden">
            <img alt="indexpict" className="w-full min-h-screen lg:min-h-0 lg:h-auto md:relative lg:relative flex bg-center mx-auto object-cover" src="/images/philosophy-bg.webp" />
            <div className="absolute inset-0 bg-gray-900 opacity-70"></div>
            <div className="absolute inset-0 flex justify-center items-center px-6 md:px-10">
                <div className="lg:w-1/2 justify-center px-8 mt-3 md:mb-0 mb-8">
                    <div className="text-white text-start ">
                        <h1 className="text-2xl text-center md:text-left font-bold mb-2 text-defaultBlue">About</h1>
                        <h1 className="text-2xl md:text-4xl text-center md:text-left font-bold mb-4 ">Indonesia Innovative Technology</h1>
                        <div className="md:text-base text-sm mb-4 text-justify">
                            <p className='mb-4'>Indonesia Innovative Technology (IIT) is a national platform designed to show the creativity and innovation of Indonesia’s young minds from elementary, junior high, and senior high school to university students.</p>
                            <p className='mb-4'>The IIT Challenge 2026 is a national-level technology competition for Elementary, Junior High School, Senior High School, and University students. The competition features four categories: Scratch Coding Game, Competitive Programming, Innovative Technology Challenge, and EcoQuest Web Application.</p>
                            <p>The Preliminary Round will be held online on October 11, 2026, followed by the Final Round on October 24, 2026, at BINUS Alam Sutera. Participants will have the opportunity to compete, develop their technological skills, and gain valuable educational experiences, with cash prizes and educational benefits with a total value equivalent to <span className="whitespace-nowrap">IDR 270,000,000.</span></p>
                        </div>
                        <RegistrationButton />
                    </div>
                </div>
                <div className="lg:w-1/2 flex justify-center items-center mx-auto">
                    <img alt="logo" src="/images/IIT-Challenge-Logo-2025.png" className="hidden md:block" width={398} height={205.86} />
                </div>
            </div>
        </div>
    )
}

const iitChallenge = () => {
    return (
        <>

            <div className='md:hidden'>
                <TitleTemp name={'IIT Philosophy'} />
            </div>

            <div className="mx-auto flex flex-col md:flex-row justify-center -mt-5">
                <img
                    src="/images/sustainable-logo.webp"
                    alt="Sustainable Logo"
                    className="bg-coverflex bg-center mx-auto object-contain h-80 md:mt-12"
                />
                <div className="w-full lg:w-2/3 px-8 py-5 my-auto justify-start">
                    <div className="md:text-left">
                        <h1 className='hidden md:block md:text-4xl font-semibold text-left mb-8 mt-8 text-defaultBlue'>IIT Philosophy</h1>
                        <p className="text-base md:text-base mb-8 text-gray-400 text-justify ">The IIT was founded as a pioneering institution in Indonesia with a strong mission to advance technological innovation and empower young talents to develop impactful solutions. Through its initiatives and competitions, IIT serves as a platform for students to showcase their skills, creativity, and innovative ideas while addressing real-world challenges through technology.</p>
                        <p className="text-base md:text-base mb-8 text-gray-400 text-justify">IIT is committed to fostering technological progress that not only drives innovation but also creates meaningful social impact. Aligned with the Sustainable Development Goals (SDGs), IIT inspires young people to turn their ideas into action by developing technology-driven solutions that contribute to a better and more sustainable future.</p>
                        <p className="text-base md:text-base text-gray-400 text-justify">n Indonesia, IIT continues to strengthen its role as a platform for nurturing future innovators by providing opportunities, guidance, and experiences that equip participants with the knowledge, skills, and confidence to create meaningful technological solutions.</p>
                    </div>
                </div>
            </div>
        </>
    );
};


const cardPhilosophy = () => {
    return (
        <div className='relative p-5 overflow-hidden w-full -mb-24'>

            <img alt='sponsor bg' className="absolute top-0 left-0 h-full w-full object-cover" src='/images/sponsor-bg.jpg' />
            <div className='w-full h-full absolute top-0 left-0 bg-darkBlue bg-opacity-70' />

            <div className="max-w-screen-lg mx-auto py-6 pb-10">
                <h1 className='relative z-20 text-white font-semibold text-4xl text-center mb-5 '>IIT Objectives</h1>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 px-8 mx-auto justify-items-center">
                    <PhilosophyCard title='Inovate Youth' desc='Advancing innovation and creativity in technology education of the younger generation on a global competition platform' url={faLightbulb} color='#fb923c' />
                    <PhilosophyCard title='Friendship Challenge' desc='Make a friendly competition that fosters a sense of collaboration, mutual respect, and mutual support between the participant' url={faPeopleGroup} color='#00b0f0' />
                    <PhilosophyCard title='Empathy Builders' desc='Increase the empathy of younger generation in solving daily life challenges, especially the 17 United Nations Sustainable Development Goals (SDGs)' url={faChartLine} color='#34d399' />
                </div>
            </div>
        </div>
    )
}


const Render = () => {
    return (
        <div>
            {Home()}
            <div className="container mx-auto mb-8">
                {iitChallenge()}

            </div>
            {cardPhilosophy()}
        </div>
    );
}

const iitPhilosophy: Page = () => {
    return (
        <div>
            {Render()}
        </div>
    );
}

iitPhilosophy.layout = WithDefaultLayout;
export default iitPhilosophy
